import { APICore } from 'src/helpers/api/apiCore';
import config from 'src/config';
const apiBaseUrl = config.API_URL;
const api = new APICore();

// add panel Category
function creatPanelCategory(params: any) {
    const baseUrl = `/panelcatg/createPanelcatg`;
    return api.create(`${baseUrl}`, params);
}
// update Panel Category
function updatePanelCategory(params: any) {
    const baseUrl = '/panelcatg/updatePanelcatg';
    return api.update(`${baseUrl}`, params);
}

// get all panel Category
function getAllPanelCategory(params: any) {
    const baseUrl = '/panelcatg/getPanelcatg';
    return api.create(`${baseUrl}`, params);
}

// get Panel Category
function getPanelCategory(params: any) {
    const baseUrl = '/panelcatg/getPanelcatgDetail';
    return api.create(`${baseUrl}`, params);
}

export { creatPanelCategory, updatePanelCategory, getAllPanelCategory, getPanelCategory };
